import React, { useEffect, createElement } from 'react';
import { Play, CheckCircle, Clock, TrendingUp } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function RetargetingPage() {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Initialize both pixels
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/ffr68lte98.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-3942">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3943">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3944" />
      </noscript>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-6 md:py-14" data-id="element-3945">
        {/* Header Section */}
        <div className="text-center mb-6 md:mb-10 space-y-4" data-id="element-3946">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-green-600/20 border border-green-500/50 rounded-full px-4 py-2 mb-4" data-id="element-3947">
            <TrendingUp className="w-4 h-4 text-green-400" data-id="element-3948" />
            <span className="text-sm font-semibold text-green-400" data-id="element-3949">
              Estudio de Caso Real
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-black leading-tight max-w-4xl mx-auto tracking-tight" data-id="element-3950">
            Cómo Generé{' '}
            <span className="text-green-500" data-id="element-3951">$200,000 Desde Cero</span> en 30
            Días – Estudio de Caso en Vivo
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-gray-100 max-w-3xl mx-auto leading-relaxed" data-id="element-3952">
            Accede a un video exclusivo donde te muestro paso a paso cómo
            apliqué la estrategia exacta que hoy enseñamos en el curso.
          </p>
        </div>

        {/* Video Section */}
        <div className="mb-12 md:mb-16" data-id="element-3953">
          <div className="relative" data-id="element-3954">
            {/* Neon green gradient shadow */}
            <div className="absolute -inset-2 bg-gradient-to-r from-green-500 via-green-400 to-green-500 opacity-75 blur-2xl" data-id="element-3955"></div>

            <div className="relative aspect-video bg-gray-900 border border-green-500/50 overflow-hidden shadow-2xl" data-id="element-3956">
              {/* Wistia Video Player */}
              <wistia-player media-id="ffr68lte98" aspect="1.7777777777777777" className="w-full h-full" data-id="element-3957"></wistia-player>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="max-w-3xl mx-auto mb-10 md:mb-14" data-id="element-3958">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-5 md:p-7 space-y-5" data-id="element-3959">
            <h2 className="text-lg md:text-xl font-bold text-center mb-5" data-id="element-3960">
              En Este Video Descubrirás:
            </h2>

            <div className="space-y-4" data-id="element-3961">
              <div className="flex items-start gap-4" data-id="element-3962">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-600/20 border border-green-500/50 flex items-center justify-center mt-1" data-id="element-3963">
                  <CheckCircle className="w-4 h-4 text-green-400" data-id="element-3964" />
                </div>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-3965">
                  Ve la estrategia exacta que utilicé para escalar de cero a
                  $200,000 en solo 30 días.
                </p>
              </div>

              <div className="flex items-start gap-4" data-id="element-3966">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-600/20 border border-green-500/50 flex items-center justify-center mt-1" data-id="element-3967">
                  <CheckCircle className="w-4 h-4 text-green-400" data-id="element-3968" />
                </div>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-3969">
                  Descubre los errores que evitamos y cómo los corregimos en
                  tiempo real.
                </p>
              </div>

              <div className="flex items-start gap-4" data-id="element-3970">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-600/20 border border-green-500/50 flex items-center justify-center mt-1" data-id="element-3971">
                  <CheckCircle className="w-4 h-4 text-green-400" data-id="element-3972" />
                </div>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-3973">
                  Aprovecha este estudio de caso práctico que ya ha ayudado a
                  cientos de alumnos a aplicar el método.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="max-w-2xl mx-auto text-center space-y-5" data-id="element-3974">
          <a href="https://www.fanbasis.com/agency-checkout/true-marketer/Yv2lp" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-b from-[#06b6d4] to-[#0891b2] hover:from-[#0891b2] hover:to-[#0e7490] text-white font-bold text-lg md:text-xl rounded-xl py-5 px-8 shadow-lg hover:shadow-[#06b6d4]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-3975">
            Accede Hoy Por Solo $297
          </a>

          {/* Payment Options */}
          <p className="text-gray-200 text-sm md:text-base" data-id="element-3976">O 4 pagos de $75</p>

          {/* Urgency */}
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4" data-id="element-3977">
            <div className="flex items-center justify-center gap-2 text-yellow-400" data-id="element-3978">
              <Clock className="w-5 h-5" data-id="element-3979" />
              <p className="text-sm md:text-base font-semibold" data-id="element-3980">
                Este video estará disponible solo por tiempo limitado. ¡Accede
                antes de que lo retiremos!
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-6 md:py-10 mt-14" data-id="element-3981">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-3982">
          <div className="mb-5" data-id="element-3983">
            <p className="text-[#06b6d4] font-bold text-lg md:text-xl mb-2" data-id="element-3984">
              48HRSCASHMACHINE.COM
            </p>
          </div>

          <div className="text-gray-300 text-xs md:text-sm leading-relaxed space-y-3" data-id="element-3985">
            <p data-id="element-3986">
              Derechos de autor © 2025, 48 Hrs AI Cash Machine: Todos los
              derechos reservados.
            </p>
            <p className="text-gray-200" data-id="element-3987">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06b6d4] hover:text-[#0891b2] transition-colors" data-id="element-3988">
                support@truemarketer.com
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}